export default __webpack_public_path__ + "static/search-page-58efa97b04dae80ebb6433e0beeff7ef.png";